module.exports = __webpack_public_path__ + "img/retail_1.8faf86ea.jpg";